module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBudgetHigh@2x.767a47f.webp";